export default __webpack_public_path__ + "static/media/IconDesc_LiquidHeavyOilResidue_Pipe.256.d144a8ef.png";